import { IDemoMeta } from '../../utils/parse';
import { copyWritingsMap } from '../exampleFilter/copywritings';
import { useContext } from 'react';
import { LanguageContext, LanguageEnum, getCDNDomain } from '../../utils';

export interface IDemoProps {
  demo: IDemoMeta;
  title: string;
  fullPath: string;
  style?: React.CSSProperties;
  demoStyle?: React.CSSProperties;
  [foo: string]: any;
}

function Demo(props: IDemoProps) {
  const demo = props.demo;
  const keywordsList: string[] = demo?.keywords
    ? demo.keywords.split(',')
    : [];
  const demoPath = 'demo' + `${props.demoType ? `-${props.demoType}` : ''}`;
  if (
    props.activeKeyword === '' ||
    keywordsList.includes(props.activeKeyword)
  ) {
    const coverSrc = demo?.cover
      ? (demo.cover || '').replace(
          'tosv.byted.org',
          'lf9-dp-fe-cms-tos.byteorg.com'
        )
      : `${getCDNDomain()}/img/vchart/bar-stack.png`;
    return (
      <div
        className="vchart-example-demo"
        onClick={() => {
          if (props.activeKeyword) {
            window.open(
              `/${props.siteType}/${demoPath}/${props.fullPath}?keyword=${props.activeKeyword}`
            );
          } else {
            window.open(`/${props.siteType}/${demoPath}/${props.fullPath}`);
          }
        }}
        style={{ ...(props.demoStyle ?? {}) }}
      >
        <div className="vchart-example-demo-img">
          <img src={coverSrc} alt="" />
        </div>
        <div className="vchart-example-demo-title">
          <a
            href={`/${props.siteType}/${demoPath}/${props.fullPath}`}
            onClick={(event) => event.preventDefault()}
          >
            {props.title}
          </a>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export function ExampleGallery(props: any) {
  const { groupDemos, activeIndex, demos, activeKeyword, siteType, demoType } =
    props;
  const { language, setLanguage } = useContext(LanguageContext);
  const copyWritings: Record<
    string,
    Record<LanguageEnum, string>
  > | undefined =
    copyWritingsMap[siteType + (demoType ? `-${demoType}` : '')];

  const groupTitle = (groupKey: string) =>
    copyWritings?.[groupKey]?.[language] ?? groupKey;
  const demoTitle = (datum: any) =>
    (datum.title && typeof datum.title === 'object' && datum.title[language]) != null
      ? datum.title[language]
      : typeof datum.title === 'string'
      ? datum.title
      : datum.meta?.title ?? '';

  if (activeIndex === 0) {
    return (
      <div className="vchart-example-demo-container">
        {(groupDemos ?? []).map((groupDemo: any) => (
          <div
            key={groupDemo.group}
            className="vchart-example-demo-container-group"
          >
            <h1
              className="vchart-example-demo-container-group-title"
              id={groupDemo.group}
            >
              {groupTitle(groupDemo.group)}
            </h1>
            <div className="vchart-example-demo-container-group-content">
              {(groupDemo.filterDemos ?? []).map((datum: any) => (
                <Demo
                  key={datum.data?.fullPath ?? datum.meta?.id}
                  demo={datum.meta}
                  title={demoTitle(datum)}
                  fullPath={datum.data?.fullPath ?? ''}
                  activeKeyword={activeKeyword}
                  siteType={siteType}
                  demoType={demoType}
                  demoStyle={props.demoStyle}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  } else {
    return (
      <div className="vchart-example-demo-container">
        <div className="vchart-example-demo-container-group">
          <h1 className="vchart-example-demo-container-group-title">
            {groupTitle(activeKeyword)}
          </h1>
          <div className="vchart-example-demo-container-group-content">
            {(demos ?? []).map((datum: any) => (
              <Demo
                key={datum.data?.fullPath ?? datum.meta?.id}
                demo={datum.meta}
                title={demoTitle(datum)}
                fullPath={datum.data?.fullPath ?? ''}
                activeKeyword={activeKeyword}
                siteType={siteType}
                demoType={demoType}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}
